/* eslint-disable */
const getters = {
  getCollections(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
